import cambridge from '../images/logos/cambridge.png'
import ecole from '../images/logos/ecole.png'
import ens from '../images/logos/ens.png'
import eth from '../images/logos/eth.svg'
import mit from '../images/logos/mit.svg'
import bnp from '../images/logos/bnp-paribas.svg'
import bdf from '../images/logos/banque-de-france.png'

export const logos = [mit, bnp, cambridge, bdf, ecole, eth, ens]
